import * as types from "./types";

/**
 *
 * Store/Reset/Remove data dynamically based on .
 * @param {Object} data - API response on success/error/loading
 * @param {String} type - type for sucess/error/loading
 */

export const onSystemConfigurationDataSuccess = (
  payload = {},
  type = types.SUCCESS_SYSTEM_CONFIGURATION_DATA
) => {
  return {
    type,
    payload
  };
};

export const isSystemConfigurationDataLoading = (
  payload = {},
  type = types.LOADING_SYSTEM_CONFIGURATION_DATA
) => {
  return {
    type,
    payload
  };
};
